import type { CatalogParam, CatalogResponseField } from "../lib/api-catalog.ts";

/** Request-parameters table: name, type, required, description. */
export function RequestParamTable({ params }: { params: CatalogParam[] }) {
  if (params.length === 0) {
    return (
      <p className="muted" style={{ fontSize: "13px", margin: 0 }}>
        No request parameters.
      </p>
    );
  }
  return (
    <div className="table-wrap">
      <table className="data">
        <thead>
          <tr>
            <th>Parameter</th>
            <th>Type</th>
            <th>Required</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {params.map((p) => (
            <tr key={`${p.in}:${p.name}`}>
              <td>
                <span className="mono strong">{p.name}</span>
                {p.in === "path" && (
                  <span className="badge badge-neutral" style={{ marginLeft: "8px" }}>path</span>
                )}
              </td>
              <td className="mono">{p.type}</td>
              <td>
                {p.required ? (
                  <span className="badge badge-warn">Required</span>
                ) : (
                  <span className="badge badge-neutral">Optional</span>
                )}
              </td>
              <td>{p.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Response-fields table: name, type, description. */
export function ResponseFieldTable({ fields }: { fields: CatalogResponseField[] }) {
  return (
    <div className="table-wrap">
      <table className="data">
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((f) => (
            <tr key={f.name}>
              <td>
                <span className="mono strong">{f.name}</span>
              </td>
              <td className="mono">{f.type}</td>
              <td>{f.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
